<template>
  <div>
    <topbar/>
    <div class="page-content">
      <slot />
    </div>
  </div>
</template>

<script>
import Topbar from '@/components/shared/light-topbar'

export default {
  components: {
    Topbar
  },
  data () {
    return {}
  },
  created: () => {
    document.body.setAttribute('data-layout', 'horizontal')
    document.body.setAttribute('data-layout', 'light')
    document.body.setAttribute('data-topbar', 'light')
  },
  methods: {
  }
}
</script>
<style scoped>
.page-content{
  margin-top:70px;
}
</style>
